import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	createAnotherButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contactAdmin: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	makeChangesInConfig: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	contactAdminGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	totalCount: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createAFieldInConfig: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	createAnotherButton: {
		id: 'native-issue-table.inline-field-config-footer.create-another-button',
		defaultMessage: 'Create another',
		description: 'Label for button in the column picker footer that creates a new field',
	},
	contactAdmin: {
		id: 'native-issue-table.inline-field-config-footer.contact-admin-text',
		defaultMessage: '<link>Contact your project admin</link> to make changes',
		description:
			'Text on footer in the column picker that tells a non-admin user to contact admin to make changes to the column list',
	},
	makeChangesInConfig: {
		id: 'native-issue-table.inline-field-config-footer.make-config-changes-text',
		defaultMessage: 'Make changes in <link>configurations</link>',
		description:
			'Text on footer in the column picker that tells a CMP admin user to make changes in Configurations',
	},
	contactAdminGalaxia: {
		id: 'native-issue-table.inline-field-config-footer.contact-admin-text-galaxia',
		defaultMessage: '<link>Contact your space admin</link> to make changes',
		description:
			'Text on footer in the column picker that tells a non-admin user to contact admin to make changes to the column list',
	},
	totalCount: {
		id: 'native-issue-table.inline-field-config-footer.of-total-count',
		defaultMessage: '{itemCount} of {totalCount}',
		description: 'Total count of items.',
	},
	createAFieldInConfig: {
		id: 'native-issue-table.inline-field-config-footer.create-a-field-in-config',
		defaultMessage: 'Create a field',
		description:
			'Text on footer in the column picker that tells a user to create a field in configurations',
	},
});
export default messages;
